(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reiter-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.rd-cgrid[data-section-id]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';

      var grid = root.querySelector('[data-grid]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
      if (!grid || !cards.length) return;

      /* ---- Per-card swatch selection: swap to the real variant photo ---- */
      function selectSwatch(card, sw) {
        if (!sw) return;
        var img = card.querySelector('.rd-pcard__img');
        var priceLabel = card.querySelector('[data-price-label]');
        var gname = card.querySelector('[data-gname]');
        var addId = card.querySelector('[data-addid]');

        // Show the colour's real photo when it has one; otherwise keep the current image
        // (no colour overlay — a variant without its own photo simply doesn't change it).
        var src = sw.getAttribute('data-img');
        if (img && src && img.tagName === 'IMG') {
          img.src = src;
          img.removeAttribute('srcset');
        }
        if (priceLabel && sw.getAttribute('data-price')) priceLabel.textContent = sw.getAttribute('data-price');
        if (gname) gname.textContent = sw.getAttribute('data-name') || '';
        if (addId && sw.getAttribute('data-id')) addId.value = sw.getAttribute('data-id');

        card.querySelectorAll('[data-sw]').forEach(function (b) { b.classList.toggle('is-on', b === sw); });
      }

      function resetCard(card) {
        var img = card.querySelector('.rd-pcard__img');
        var priceLabel = card.querySelector('[data-price-label]');
        var gname = card.querySelector('[data-gname]');
        var addId = card.querySelector('[data-addid]');
        if (img && img.tagName === 'IMG') { img.src = card.getAttribute('data-init-img'); img.removeAttribute('srcset'); }
        if (priceLabel) priceLabel.textContent = card.getAttribute('data-init-price');
        if (gname) gname.textContent = card.getAttribute('data-init-color') || '';
        if (addId) addId.value = card.getAttribute('data-init-id');
        var initSw = card.querySelector('[data-sw][data-name="' + cssEscape(card.getAttribute('data-init-color')) + '"]');
        card.querySelectorAll('[data-sw]').forEach(function (b) { b.classList.toggle('is-on', b === initSw); });
      }

      function cssEscape(s) { return (s || '').replace(/"/g, '\\"'); }

      cards.forEach(function (card) {
        card.querySelectorAll('[data-sw]').forEach(function (sw) {
          sw.addEventListener('click', function (e) {
            e.preventDefault();
            selectSwatch(card, sw);
          });
        });
      });

      /* ---- Toolbar glaze row (built from the union of card swatches) ---- */
      var filters = root.querySelector('[data-filters]');
      var allBtn = filters ? filters.querySelector('[data-glaze="all"]') : null;
      if (filters) {
        var seen = {};
        var union = [];
        cards.forEach(function (card) {
          card.querySelectorAll('[data-sw]').forEach(function (sw) {
            var n = sw.getAttribute('data-name');
            if (n && !seen[n]) { seen[n] = 1; union.push({ name: n, hex: sw.getAttribute('data-hex') }); }
          });
        });
        union.forEach(function (c) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'rd-cgrid__gd';
          b.setAttribute('data-glaze', c.name);
          b.title = c.name;
          b.setAttribute('aria-label', c.name);
          var dot = document.createElement('span');
          dot.className = 'rd-cgrid__sw';
          dot.style.background = c.hex || 'var(--rd-border-strong)';
          b.appendChild(dot);
          filters.appendChild(b);
        });

        filters.addEventListener('click', function (e) {
          var b = e.target.closest('.rd-cgrid__gd');
          if (!b) return;
          var glaze = b.getAttribute('data-glaze');
          filters.querySelectorAll('.rd-cgrid__gd').forEach(function (x) { x.classList.toggle('is-on', x === b); });
          if (glaze === 'all') {
            cards.forEach(function (card) { card.classList.remove('is-dimmed'); resetCard(card); });
            return;
          }
          cards.forEach(function (card) {
            var match = card.querySelector('[data-sw][data-name="' + cssEscape(glaze) + '"]');
            if (match) { card.classList.remove('is-dimmed'); selectSwatch(card, match); }
            else { card.classList.add('is-dimmed'); }
          });
        });
      }

      /* ---- Sorting (client-side over the rendered cards) ---- */
      var sorts = root.querySelector('[data-sorts]');
      if (sorts) {
        sorts.addEventListener('click', function (e) {
          var b = e.target.closest('button');
          if (!b) return;
          var key = b.getAttribute('data-sort');
          sorts.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-on', x === b); });
          var arr = cards.slice();
          arr.sort(function (a, c) {
            var pa = parseInt(a.getAttribute('data-price'), 10) || 0;
            var pc = parseInt(c.getAttribute('data-price'), 10) || 0;
            var oa = parseInt(a.getAttribute('data-order'), 10) || 0;
            var oc = parseInt(c.getAttribute('data-order'), 10) || 0;
            if (key === 'price-asc') return pa - pc || oa - oc;
            if (key === 'price-desc') return pc - pa || oa - oc;
            if (key === 'new') return (parseInt(c.getAttribute('data-new'), 10) || 0) - (parseInt(a.getAttribute('data-new'), 10) || 0) || oa - oc;
            return oa - oc; /* featured */
          });
          arr.forEach(function (card) { grid.appendChild(card); });
        });
      }

      /* ---- Quick-add (AJAX) → Horizon cart drawer ---- */
      /* Handled in the module script below, which can import @shopify/events to dispatch
         Horizon's real CartLinesUpdateEvent. An inline static javascript block cannot import. */
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
